import React, { useEffect } from 'react';
import { LogList, ProAppProfilesProvider } from '../../../../../../shared/LogList';
import { View } from 'react-native';
import { LogPressArgs } from '../../../../../../shared/LogList/LogList';
import {
    SideDrawerButtonContainer,
    SideDrawerButtonProps,
} from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../../../../../utils/intl';
import AuditLogDetails, { useDeleteAuditLogActionButton } from '../../../../../../shared/AuditLogDetails';
import { PRScrollView } from '../../../../../../shared/Scroll';

const intl = getIntl('clients-activity-side-drawer-content', {
    backToList: 'Back to list',
});

export type ClientsActivitySideDrawerContentOwnProps = {
    clientMedicalProfileIds: string[];
};

export type ClientsActivitySideDrawerContentProps = ClientsActivitySideDrawerContentOwnProps;

const FocusedLogContent: React.FC<{ auditLogId: string; profileId: string; onDismiss: () => void }> = ({
    auditLogId,
    profileId,
    onDismiss,
}) => {
    const { deleteAuditLogAction } = useDeleteAuditLogActionButton({
        auditLogId,
        medicalProfileFileId: profileId,
        onDeleted: onDismiss,
    });

    const sideDrawerActions: SideDrawerButtonProps[] = [];

    if (deleteAuditLogAction.show) {
        sideDrawerActions.push({
            title: deleteAuditLogAction.title,
            icon: deleteAuditLogAction.icon,
            onPress: deleteAuditLogAction.onPress,
            variant: 'alert' as const,
            testID: deleteAuditLogAction.testID,
            isDisabled: deleteAuditLogAction.isDisabled,
        });
    }

    sideDrawerActions.push({
        title: intl('backToList'),
        icon: 'ArrowLeft',
        onPress: onDismiss,
        variant: 'secondary' as const,
        testID: 'back-to-client-activity-list-button',
    });

    return (
        <SideDrawerButtonContainer contentContainerStyle={{ padding: 0 }} buttons={sideDrawerActions}>
            <PRScrollView
                style={{ width: '100%', height: '100%' }}
                contentContainerStyle={{
                    flexGrow: 1,
                    width: '100%',
                }}
                collapsable={false}
            >
                <AuditLogDetails auditLogId={auditLogId} profileId={profileId} />
            </PRScrollView>
        </SideDrawerButtonContainer>
    );
};

const ClientsActivitySideDrawerContent: React.FC<ClientsActivitySideDrawerContentProps> = (props) => {
    const [focusedLogPressArgs, setFocusedLogPressArgs] = React.useState<LogPressArgs | null>(null);

    useEffect(() => {
        if (focusedLogPressArgs && !focusedLogPressArgs.medicalProfileId) {
            setFocusedLogPressArgs(null);
        }
    }, [focusedLogPressArgs]);

    if (focusedLogPressArgs && !focusedLogPressArgs.medicalProfileId) return null;

    if (focusedLogPressArgs && focusedLogPressArgs.medicalProfileId) {
        return (
            <FocusedLogContent
                auditLogId={focusedLogPressArgs.auditLogId}
                profileId={focusedLogPressArgs.medicalProfileId}
                onDismiss={() => setFocusedLogPressArgs(null)}
            />
        );
    } else {
        return (
            <ProAppProfilesProvider medicalProfileIds={props.clientMedicalProfileIds}>
                {(state) => (
                    <View style={{ width: '100%', height: '100%' }} testID="log-list-container" collapsable={false}>
                        <LogList {...state} disableSelection onLogPress={setFocusedLogPressArgs} />
                    </View>
                )}
            </ProAppProfilesProvider>
        );
    }
};

export default React.memo(ClientsActivitySideDrawerContent);
